<template>
  <div ref="imweb" v-draggable="draggableValue" :class="$style.imWeb">
    <div :class="$style.animateBox" @click="handleToggleShow">
      <img
        v-show="animatedScene === 1"
        src="https://te--fileservers.oss-cn-hangzhou.aliyuncs.com/web/im-animated/animated-enter.gif"
        alt=""
      />
      <img
        v-show="animatedScene === 2"
        src="https://te--fileservers.oss-cn-hangzhou.aliyuncs.com/web/im-animated/animated-message.gif"
        alt=""
      />
    </div>
    <div v-show="showIm" :class="$style.iframeContainer">
      <iframe ref="receiver" :src="iframeSrc" frameborder="0" scrolling="no" width="100%" height="100%"></iframe>
    </div>
  </div>
</template>

<script>
import { Draggable } from 'draggable-vue-directive';
import { mapMutations, mapGetters } from 'vuex';
import storeUser from '@/store/modules/user.js';
import storeIm, { UPDATE_CONVERSATION_TARGET, UPDATE_SHOW_STATUS } from '@/store/modules/im.js';

import { activateConversation } from '@/api/im.js';

export default {
  name: 'ImWeb',
  directives: {
    Draggable,
  },
  data() {
    return {
      iconService: ZP.param.commonUrl.contactSellerLarge,
      iframeSrc: ENV_CONFIG.imUrl, // im项目地址
      isActivating: false, // 是否正在激活im会话
      animatedScene: 1, // im动画场景：入场&静止、新消息提示
      // 拖拽配置
      draggableValue: {
        resetInitialPos: false, // 为true时, 打开im窗口后拖拽对象去回到初始位置
        onDragStart: this.handleDragStart,
        onDragEnd: this.handleDragEnd,
      },
      dragStartPositionn: { top: 0, left: 0 },
      dragEndPositionn: { top: 0, left: 0 },
    };
  },
  computed: {
    ...mapGetters(storeUser.name, ['imUserId']),
    ...mapGetters(storeIm.name, ['targetId', 'showIm']),
    // 判断是拖拽还是点击事件
    isDrag() {
      return (
        Math.abs(this.dragEndPositionn.top - this.dragStartPositionn.top) > 5 ||
        Math.abs(this.dragEndPositionn.left - this.dragStartPositionn.left) > 5
      );
    },
  },
  watch: {
    imUserId: {
      handler(value) {
        this.iframeSrc = `${ENV_CONFIG.imUrl}/#/login?userId=${value}&client=MANAGE&t=${Date.now()}`;
      },
      immediate: true,
    },
    targetId(value) {
      // postMessage通知IM更新当前会话
      this.handleSendMessage({
        type: 1,
        name: `更新会话: ${value}`,
        payload: {
          targetId: value,
        },
      });
    },
    showIm(value) {
      // 展开时将当前会话滚动到最底端
      if (value) {
        this.handleSendMessage({
          type: 2,
          name: `滚动聊天内容区到最底端`,
        });
      }
    },
  },
  mounted() {
    // 监听IM有新消息通知（postMessage推送）
    window.addEventListener('message', this.handleReceiveMessage, false);
    /**
     * 激活新会话，并打开IM窗口
     * reqBody参数说明
     * targetUserId: 目标用户id
     * activeType: 0-打招呼 1-商品 2-订单
     * referId: 根据activeType值变化 0-忽略参数 1-产品id 2-订单id
     */
    this.$root.$on('activate-conversation', async ({ reqBody, callback }) => {
      if (this.isActivating) {
        return;
      }
      this.isActivating = true;
      console.log('正在激活IM会话：', reqBody.targetUserId);
      try {
        const userId = await activateConversation(reqBody);
        this.updateConversation(userId);
        this.updateImShowStatus(true);
        this.animatedScene = 1;
      } catch (err) {
        ZP.messageError('激活IM会话失败：', reqBody.targetUserId);
      } finally {
        this.isActivating = false;
        callback();
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleReceiveMessage);
    this.$root.$off('activate-conversation');
  },
  methods: {
    ...mapMutations(storeIm.name, {
      updateConversation: UPDATE_CONVERSATION_TARGET,
      updateImShowStatus: UPDATE_SHOW_STATUS,
    }),
    // 第一次触发事件,如果未设置目标元素的left和left值时absolutePosition为undefined
    handleDragStart(positionDiff, absolutePosition, event) {
      event.preventDefault(); // fix: firefox bug
      if (!absolutePosition) {
        const { top, left } = this.$refs.imweb.getBoundingClientRect();
        this.dragStartPositionn = { top, left };
      } else {
        this.dragStartPositionn = absolutePosition;
      }
    },
    handleDragEnd(positionDiff, absolutePosition, event) {
      // 窗口宽高
      const clientWidth = document.documentElement.clientWidth;
      const clientHeight = document.documentElement.clientHeight;
      // 拖拽对象clientrect
      const clientRect = this.$refs.imweb.getBoundingClientRect();
      this.dragEndPositionn = absolutePosition;
      // 拖拽对象定位参数, 超出窗口范围时拉回
      let top = absolutePosition.top;
      let left = absolutePosition.left;
      if (absolutePosition.top <= 0) {
        top = 0;
      } else if (absolutePosition.top >= clientHeight - clientRect.height) {
        top = clientHeight - clientRect.height;
      }
      if (absolutePosition.left <= 0) {
        left = 0;
      } else if (absolutePosition.left >= clientWidth - clientRect.width) {
        left = clientWidth - clientRect.width;
      }
      this.draggableValue.resetInitialPos = true;
      this.draggableValue.initialPosition = { top, left };
      setTimeout(() => {
        this.draggableValue.resetInitialPos = false;
      }, 0);
    },
    handleToggleShow() {
      console.log('isDrag: ', this.isDrag);
      if (this.isDrag) {
        return;
      }
      this.updateImShowStatus(!this.showIm);
      this.animatedScene = 1;
    },
    /**
     * 主窗口向iframe发送postMessage消息
     * 1. 点击IM图标设置当前会话
     */
    handleSendMessage(message) {
      const iframeWindow = this.$refs.receiver.contentWindow;
      // 指定能接受消息的事件窗口
      const targetOrigin = ENV_CONFIG.imUrl;
      iframeWindow.postMessage(JSON.stringify(message), targetOrigin);
    },
    // 监听iframe的postMessage消息
    handleReceiveMessage(ev) {
      const fromOrigin = ENV_CONFIG.imUrl;
      if (!fromOrigin.includes(ev.origin)) {
        return;
      }
      const { type, name } = JSON.parse(ev.data);
      // 消息名称
      console.log(type, name);
      if (type === 1) {
        // IM新消息通知: 收到新消息动画处理
        if (!this.showIm) {
          // im新消息动画
          this.animatedScene = 2;
        }
      } else if (type === 2) {
        // IM窗口收起通知(窗口的关闭按钮在IM应用内部)
        this.updateImShowStatus(false);
      } else if (type === 3) {
        // 重新加载页面
        location.reload();
      }
    },
  },
};
</script>

<style lang="less" module>
@import '~@/styles/vars.less';

.im-web {
  position: fixed;
  top: calc(100% - 120px);
  right: 20px;
  width: 80px;
  z-index: 1999;
}

.animate-box {
  cursor: pointer;

  > img {
    width: 100%;
    height: auto;
    // pointer-events: none; // 可禁止firefox拖动图片时在新标签页打开图片
  }
}

.iframe-container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  overflow: auto;

  > iframe {
    min-width: 1140px;
    min-height: 720px;
  }
}
</style>
